module.exports = __webpack_public_path__ + "assets/img/b3ef-cy.svg";